export const LINKER_PAYLOAD_LEAVING_GROUP_REQUIRES_LINKER_PAYLOAD_ERROR =
  'Select a linker-payload before choosing its leaving group.';
export const LINKER_PAYLOAD_LEAVING_GROUP_MALFORMED_ERROR =
  'Linker-payload leaving group must be a leaving group such as LG1.';
